import { makeTheme } from './theme';
import { BrandKey } from './brand';

// Default export — Aegix-branded theme for static consumers.
const aegixTheme = makeTheme(BrandKey.Aegix);
export default aegixTheme;

// Named export for dynamic usage
export { makeTheme };

export {
  ALL_BRAND_KEYS,
  BRAND_DISPLAY_NAMES,
  BRAND_HOSTNAMES,
  BrandKey,
  hostnameFor,
  hostnameToBrandKey,
  resolveBrandKey,
} from './brand';
export type { ResolveBrandKeyInput } from './brand';

export { getBrandAssets } from './brand-assets';
export type { BrandAssets } from './brand-assets';

export * from './components';
export * from './map-accessibility';
